async function reportError(payload) {
  const { graphQLErrors, networkError, operation } = payload

  let errorType = 'Unknown'
  let errorMessage = 'Unknown error'

  if (graphQLErrors?.length > 0) {
    errorType = 'GraphQL Error'
    errorMessage = graphQLErrors
      .map((err) => {
        const details = []
        details.push(err.message)
        if (err.extensions?.code) details.push(`(${err.extensions.code})`)
        if (err.path) details.push(`Path: ${err.path.join('.')}`)
        return details.join(' ')
      })
      .join('\n')
  } else if (networkError) {
    errorType = 'Network Error'
    errorMessage = networkError.message || String(networkError)
    if (networkError.statusCode) {
      errorMessage += ` (Status: ${networkError.statusCode})`
    }
  }

  try {
    await fetch(`${process.env.REACT_APP_GRAPHQL_BASE_URL}/report-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        errorType,
        errorMessage,
        operation: operation?.operationName,
        path: window.location.pathname,
        timestamp: new Date().toISOString(),
      }),
    })
  } catch (err) {
    console.warn('Failed to report error', err)
  }
}
export default reportError
